import { featureFlags } from "../services/featureFlags";

export function useFeatureFlag(key: string): () => boolean {
    return () => featureFlags()[key] === true;
}
